import React from "react";
import PhotoTag, {getDisplayPhotoTag} from "../tag/PhotoTag";

interface TruncatedPhotoTagsProps {
    tags: string[];
    count?: number;
    bold?: boolean;
    charLimit?: number;
}

const TruncatedPhotoTags: React.FC<TruncatedPhotoTagsProps> = ({ tags, count = 0, bold = false }) => {
    const charLimit = 16;
    const displayTags = tags.map(getDisplayPhotoTag);
    if (displayTags.length >= 2) {
        const [firstTag, secondTag] = displayTags;
        const originalSecondTag = tags[1];
        const totalLength = firstTag.length + secondTag.length;
        let displaySecondTag = secondTag;
        if (totalLength > charLimit) {
            displaySecondTag = secondTag.slice(0, Math.max(0, charLimit - firstTag.length - 3)) + '...';
        }
        return (
            <>
                <div key={firstTag} className={"d-inline-block mt-1 mr-1"}>
                    <PhotoTag name={firstTag} count={count} bold={bold} />
                </div>
                <div key={secondTag} className={"d-inline-block mt-1 mr-1"}>
                    <PhotoTag name={displaySecondTag} tagLink={originalSecondTag} count={count} bold={bold} />
                </div>
            </>
        );
    } else {
        return <>
            {tags.map((tag) => (
                <div key={tag} className={"d-inline-block mt-1 mr-1"}>
                    <PhotoTag name={tag} count={count} bold={bold} />
                </div>
            ))}
        </>;
    }
};

export default TruncatedPhotoTags;
